"use client";

import { motion } from "framer-motion";
import { staggerContainer, staggerItem, viewportOnce } from "@/lib/motion";
import { AccentColor } from "@/lib/colors";

const textColor: Record<AccentColor, string> = {
  [AccentColor.Bubblegum]: "text-bubblegum",
  [AccentColor.Lavender]: "text-lavender",
  [AccentColor.Aegean]: "text-aegean",
  [AccentColor.Success]: "text-success",
  [AccentColor.Warning]: "text-warning",
  [AccentColor.Error]: "text-error"
};

type Stat = {
  value: string;
  label: string;
  desc: string;
  color?: AccentColor;
};

type StatsGridProps = {
  stats: Stat[];
  color?: AccentColor;
};

export function StatsGrid({
  stats,
  color = AccentColor.Bubblegum
}: StatsGridProps) {
  return (
    <motion.div
      className="grid grid-cols-1 md:grid-cols-3 gap-6"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={staggerContainer}
    >
      {stats.map((stat) => {
        const cardColor = stat.color ?? color;
        return (
          <motion.div
            key={stat.label}
            variants={staggerItem}
            className="bg-bg-surface rounded-2xl p-8 text-center"
          >
            <p
              className={`font-display text-4xl font-bold ${textColor[cardColor]}`}
            >
              {stat.value}
            </p>
            <p className="mt-2 font-body text-sm font-bold text-text-primary uppercase tracking-widest">
              {stat.label}
            </p>
            <p className="mt-2 text-text-muted text-sm">{stat.desc}</p>
          </motion.div>
        );
      })}
    </motion.div>
  );
}
